import React from "react";

export const Asterisk = (props) => <span style={{ color: "red", marginLeft:5, marginRight:5 }}>*</span>;
